const FETCH_POSTING = 'leads/postingFiltered/FETCH_POSTING';
const FETCH_POSTING_SUCCEEDED = 'leads/postingFiltered/FETCH_POSTING_SUCCEEDED';
const FETCH_POSTING_FAILED = 'leads/postingFiltered/FETCH_POSTING_FAILED';

const NO_POSTING = 'leads/postingFiltered/FETCH_POSTING_FAILED';

export { FETCH_POSTING, FETCH_POSTING_SUCCEEDED, FETCH_POSTING_FAILED, NO_POSTING };
